import { render, staticRenderFns } from "./CrudRatingModal.vue?vue&type=template&id=ccc2235c&"
import script from "./CrudRatingModal.vue?vue&type=script&lang=js&"
export * from "./CrudRatingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports